// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","startButton":"App_startButton__89Iux","info":"App_info__jBkAr"};